import { useEffect, useState } from 'react';
import { Button, Col, Form, Input, Row, Select, Modal, message } from 'antd';
import { ToastContainer } from 'react-toastify';
import { handlePostApi, handleUpdatePostApi } from '@/api/crud';
import { barcodeApiEndPoints, branchAccessEndpoints } from '@/api/endpoints';
import { useFetch } from '@/hooks';
import { optionSearchFunction } from '@/utils/common';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import {
  // VoucherFooterButton,
  VoucherFooterButtonAdmin,
} from '@/pages/vouchers/VoucherComponent';
import { useLocation, useNavigate } from 'react-router-dom';

// const pageStyle = `
//   @page {
//         size: 100mm 13mm;
//         margin: 0;
//       }
//       @media print {
//       body {
//           margin: 0;
//           padding: 0;
//         }
//       barcode-container {
//             height: 100%;
//         }
//         .barcode-details {
//           margin-left: 30mm;
//           display: flex;
//           width: 70mm;
//           height: 13mm;
//         }
//         .barcode-item {
//           display: inline-flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           width: auto;
//           height: 13mm;
//           /*margin-left: 66mm;*/
//           page-break-inside: avoid;
//           gap: 0.5px;
//         }
//         .barcode-secondItem {
//           width: 40%;
//           display: flex;
//           flex-direction: column;
//           /* column-gap: 5px; */
//           margin-left: -10mm;
//           /* grid-template-columns: 80% 80%; */
//           /* gap: 2px; */
//           align-self: center;
//         }
//       }
// `;

const pageStyle = ``;

const CreatePrinter = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { branchId, referenceId } = location.state || [];
  const { data } = useFetch(branchAccessEndpoints.retrieveList);

  // Function to copy CSS to clipboard after confirmation
  const confirmCopyCSS = () => {
    Modal.confirm({
      title: 'Confirm Copy',
      content: 'Do you want to copy the global CSS to the clipboard?',
      onOk: async () => {
        try {
          await navigator.clipboard.writeText(pageStyle);
          message.success('CSS copied to clipboard!');
        } catch (err) {
          message.error('Failed to copy CSS.');
          console.error('Error copying CSS:', err);
        }
      },
      onCancel: () => {
        message.info('Copy canceled.');
      },
      okText: 'Yes, Copy',
      cancelText: 'No, Cancel',
    });
  };

  useEffect(() => {
    const fetchEditData = async () => {
      if (referenceId) {
        const res = await barcodeApiEndPoints.retrieveList(referenceId);
        form.setFieldsValue(res.data.data);
      }
    };
    fetchEditData();
  }, [branchId, referenceId]);
  const navigateToList = () => {
    navigate('/printer/list/');
  };

  return (
    <Form
      layout="vertical"
      className="username"
      form={form}
      style={{
        padding: '0 15px',
      }}
      onFinish={(value) => {
        referenceId
          ? handleUpdatePostApi(
              referenceId,
              barcodeApiEndPoints.update,
              value,
              setLoading,
              form,
              () => {},
              navigateToList,
            )
          : handlePostApi(
              barcodeApiEndPoints.create,
              value,
              setLoading,
              form,
              navigateToList,
            );
      }}
    >
      <ToastContainer />
      <GlobalDivider name="Printer Settings" />
      <Row gutter={[16, 0]} justify="space-between">
        <Col xs={{ span: 24 }} lg={{ span: 8 }}>
          <Form.Item
            label="Select Branch"
            name="branchId"
            validateTrigger="onChange"
            required
          >
            <Select
              showSearch
              placeholder="Select branch"
              filterOption={optionSearchFunction}
              options={data?.map((item) => ({
                value: item.referenceId,
                label: item?.name,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
      {/* <Form.Item label="Barcode" name="barcodeCss" required>
        <Input.TextArea rows={15} />
      </Form.Item> */}
      <VoucherFooterButtonAdmin />
    </Form>
  );
};

export default CreatePrinter;
